import { FeatureAppMemoryStoreV1 } from "@volkswagen-onehub/feature-app-memory-store";

/**
 * This implementation of the FeatureAppMemoryStore can be used in the browser for feature apps that do not want to cache and share the bff data.
 */
export class NoCacheMemoryStore<T> implements FeatureAppMemoryStoreV1<T> {
  private state?: T;
  setState(state: T): void {
    this.state = state;
  }
  getState(): T | undefined {
    return this.state;
  }
}
